import{useContext as o}from'react';import{ToastContext as t}from'../../components/basic/ToastHandler/ToastContext.js';const r=()=>o(t);export{r as useToasts};
